import styled, { css } from 'styled-components';
import { lighten } from 'polished';

import 'antd/lib/spin/style/index.css';

export const PageTitle = styled.div`
  margin: 0 auto 30px auto;
  width: auto;
  max-width: 1068px;
  display: flex;
  flex-direction: column;
  align-items: space-between;
  /* div:nth-child(2) {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 3px;
  } */
  div.headerInline {
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;
  }

  h3 {
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    margin-top: 4px;
    color: #235f6e;
  }
  p {
    margin-left: 10px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    color: #999999;
    span {
      text-transform: capitalize;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.21;
      letter-spacing: 0.01px;
      color: #74a50a;
    }
  }
  span {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: 0.01px;
    text-align: left;
    color: #619b30;
  }
  div.voltar {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-right: 20px;
    padding-top: 2px;
    button {
      display: flex;
      align-items: center;
      flex-direction: row;
      border: none;
      background: none;
      color: #619b30;
      font-weight: bold;
    }
  }
`;

export const BoxContent = styled.div`
  width: 1068px;
  min-height: 400px;
  padding: 20px 10px;
  margin: 0 auto;
  border: solid 0.8px #ebebeb;
  background-color: #f9f9f9;
  div.boxSpin {
    display: flex;
    justify-content: center;
    padding: 50px;
  }
`;

export const BoxContentHeader = styled.div`
  padding: 10px 22px;
  height: 30px;

  svg {
    color: #dddbdb;
  }

  span {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 13px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.23;
    letter-spacing: 0.01px;
    color: #727272;
  }
`;

export const BoxList = styled.div`
  width: 100%;
  min-height: 70px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  margin-top: 15px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #235f6e;

  div.nomeUsuario {
    min-height: 70px;
    display: flex;
    align-items: center;
    padding-left: 15px;
    letter-spacing: 0px;
    text-align: left;
    color: #235f6e;
  }

  div.email {
    min-height: 70px;
    display: flex;
    align-items: center;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: 0.46px;
    color: #235f6e;
  }

  div.data {
    min-height: 70px;
    display: flex;
    align-items: center;
    font-size: 15px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: 0.01px;
    text-align: center;
    color: #235f6e;
  }

  div.horaLogin {
    min-height: 70px;
    display: flex;
    align-items: center;
    font-size: 15px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: 0.01px;
    text-align: left;
    color: #235f6e;
  }

  div.buttons {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding-right: 20px;
    button {
      color: #fff;
      border: none;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      height: 34px;
      border-radius: 3.5px;
      background-color: #74a50a;
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.15;
      letter-spacing: normal;
      text-align: right;
      color: #ffffff;
      a {
        color: #fff;
        margin: 0;
        padding: 0;
        display: block;
        padding: 10px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
      }

      svg,
      img {
        margin-right: 5px;
      }
      &:first-child {
        width: 114px;
        &:hover {
          background-color: ${lighten(0.1, '#74a50a')};
        }
      }
      &:nth-child(2) {
        margin-left: 20px;
        width: 157px;
        background-color: #398ca1;
        &:hover {
          background-color: ${lighten(0.1, '#398ca1')};
        }
      }
      &:last-child {
        width: 77px;
        background-color: #235f6e;

        margin-left: 20px;
        &:hover {
          background-color: ${lighten(0.1, '#235f6e')};
        }
      }
    }
  }
`;

export const BoxPagination = styled.div`
  padding: 40px 30px 30px 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  ul {
    color: #235f6e;
    a {
      color: #235f6e;
      font-size: 13px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: 0.01px;

      svg {
        margin-bottom: -8px;
      }
    }

    a.arrowLeft {
      display: inline-block;
      margin-right: 70px;
    }
    a.arrowRight {
      display: inline-block;
      margin-left: 70px;
    }

    li.ant-pagination-item {
      border: none;
      background-color: transparent;
      min-width: 26px;
      min-width: 26px;
      height: 26px;
      line-height: 24px;
      a {
        font-size: 13px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: 0.01px;
        color: #235f6e;
      }
    }
    li.ant-pagination-item-active {
      background-color: #74a50a;
      border-radius: 0;
      a {
        color: #fff;
      }
    }
  }
`;

export const SearchContainer = styled.div`
  ${() => css`
    margin-left: 20px;
    form {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    div.ant-select {
      margin-right: 8px;

      span {
        font-size: 12px;
      }
    }

    /* 
    *  
    * ANT SELECT
    *
    */

    .ant-select-selection:hover {
      border: 1px solid #74a50a;
    }

    .ant-select-focused .ant-select-selection,
    .ant-select-selection:focus,
    .ant-select-selection:active {
      border-color: #74a50a;
      border-right-width: 1px !important;
      outline: 0;
      -webkit-box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    }

    .ant-select-open .ant-select-selection {
      border-color: #74a50a;
    }

    .ant-select-dropdown.ant-select-dropdown--multiple
      .ant-select-dropdown-menu-item-selected
      .ant-select-selected-icon,
    .ant-select-dropdown.ant-select-dropdown--multiple
      .ant-select-dropdown-menu-item-selected:hover
      .ant-select-selected-icon {
      display: inline-block;
      color: #74a50a;
    }

    /* 
    *  
    * ANT SELECT
    *
    */

    label.search {
      width: 244.5px;
      height: 33.4px;
      padding: 0 10px;
      border-radius: 3px;
      box-shadow: inset 0px 1px 0px 0px #c7c7c794;
      border: solid 1px #c7c7c794;
      background: #ffffff;
      display: flex;
      flex-direction: row;
      align-items: center;

      input {
        border: 0;
        color: #74a50a;
        margin: 0 0 0 5px;
        &::placeholder {
          color: #282828;
        }
      }
    }

    button {
      margin-left: 4px;
    }
    button.limparBusca {
      width: 90px;
      height: 34px;
      border-radius: 3.5px;
      background-color: #235f6e;
      border: none;
      color: #ffffff;
      margin-left: 10px;
    }
  `}
`;

export const BoxAsyncSelect = styled.div`
  width: 220px;

  input[type='text'] {
    box-shadow: inset 0px 1px 0px 0px #fff;
  }

  span {
    font-size: 4px;
  }
`;

export const DatePickerContainer = styled.div`
  width: 300px;
  display: flex;
  padding-right: 10px;

  .ant-calendar-picker-input.ant-input {
    line-height: 1;
  }
`;
